<template>
  <main class="main-content">
    <section class="section-header">
      <h1>开发指南</h1>
      <p>详细的开发指南帮助您快速上手银企通™ API平台</p>
    </section>

    <div class="section">
      <h2>开发准备</h2>
      <p>在开始开发之前，请确保您已完成以下准备工作：</p>

      <ul>
        <li>注册银企通™ API平台开发者账号</li>
        <li>创建应用并获取AppID和API Key</li>
        <li>熟悉银企通™ API平台的API文档</li>
        <li>准备好开发环境（推荐使用Node.js、Python或Java）</li>
      </ul>
    </div>

    <div class="section">
      <h2>集成步骤</h2>
      <ol>
        <li><strong>环境配置</strong> - 安装必要的依赖和SDK</li>
        <li><strong>认证设置</strong> - 配置AppID和API Key</li>
        <li><strong>接口调用</strong> - 实现核心API调用逻辑</li>
        <li><strong>数据处理</strong> - 处理返回的数据并集成到业务系统</li>
        <li><strong>测试验证</strong> - 在测试环境中验证功能</li>
      </ol>
    </div>

    
    <div class="section">
      <h2>常见问题</h2>
      <ul>
        <li><strong>API调用频率限制</strong> - 默认限制为每分钟100次请求</li>
        <li><strong>数据更新延迟</strong> - 银行流水数据通常有1-2小时的延迟</li>
        <li><strong>错误处理</strong> - 请务必处理各种错误码和异常情况</li>
      </ul>
    </div>
  </main>
</template>

<script setup lang="ts">
import { useCodeHighlight } from "@/composables/useCodeHighlight";

// 使用代码高亮功能
useCodeHighlight("pre code");
</script>

<style scoped>
.section-header {
  margin-bottom: 2rem;
}

.section-header h1 {
  font-size: 2rem;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.section-header p {
  color: var(--text-secondary);
  font-size: 1.1rem;
}

.section {
  background-color: white;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.section h2 {
  font-size: 1.5rem;
  color: var(--text-primary);
  margin-bottom: 1rem;
}

.section h3 {
  font-size: 1.2rem;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
  margin-top: 1rem;
}

.section ul,
.section ol {
  padding-left: 1.5rem;
  margin-bottom: 1rem;
}

.section li {
  margin-bottom: 0.5rem;
}

.sdk-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-top: 1rem;
}

.sdk-item {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
}

.sdk-item h3 {
  margin-top: 0;
}

pre {
  background-color: #e9ecef;
  border-radius: 4px;
  padding: 0.5rem;
  overflow-x: auto;
  font-size: 0.9rem;
  margin-top: 0.5rem;
}
</style>
